// extracted by mini-css-extract-plugin
export default {"menuIcon":"menuLogout_menuIcon__W0thx"};